import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import portfolioList from "../data/portfolio.js";

import "../scss/portfolio.scss"

function Portfolio() {
  const { pageName } = useParams();
  const [tap, setTap] = useState(0);

  useEffect(() => {
    switch (pageName) {
      case "All":
        setTap(0);
        break;
      case "원페이지형":
        setTap(1);
        break;
      case "표준형":
        setTap(2);
        break;
      case "심화개발형":
        setTap(3);
        break;
      case "쇼핑몰":
        setTap(4);
        break;

      default:
        break;
    }
  })
  let list = [];
  for (let i = 1; i < 5; i++) {
    if (tap === 0) {
      list = [...portfolioList];
    } else if (tap === i) {
      for (let j = 0; j < portfolioList.length; j++) {
        if (portfolioList[j].type === pageName) {
          list = [...list, portfolioList[j]];
        }
      }
    }
  }

  return (
    <div className="portfolioDetail">
      <nav>
        <ul>
          <li className={tap === 0 ? "on" : ""}><Link to="/portfolio/All">전체</Link></li>
          <li className={tap === 1 ? "on" : ""}><Link to="/portfolio/원페이지형">원페이지형</Link></li>
          <li className={tap === 2 ? "on" : ""}><Link to="/portfolio/표준형">표준형</Link></li>
          <li className={tap === 3 ? "on" : ""}><Link to="/portfolio/심화개발형">심화개발형</Link></li>
          <li className={tap === 4 ? "on" : ""}><Link to="/portfolio/쇼핑몰">쇼핑몰</Link></li>
        </ul>
      </nav>

      <div className="wrap">
        <ul className="list">
          {
            list.map((a, i) => {
              return (
                <li key={i}>
                  <a href={a.url}>
                    <img src={`/image/portfolio/${a.imageUrl}.jpg`} alt="" />
                  </a>
                </li>
              )
            })
          }
        </ul>
      </div>
    </div>
  )
}

export default Portfolio;